module.exports = __webpack_public_path__ + "static/media/Dual Ring-1s-79px.94de242f.svg";